module.exports = __webpack_public_path__ + "img/check_off.553f0ca9.svg";